<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-50 p-0">

            <form @submit.prevent="update()">
                <div class="modal-header p-3">
                    <h5 class="mb-0">Editar Usuário</h5>
                    <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
                </div>

                <div class="modal-body p-3">
                    
                    <div class="mb-3 d-flex gap-2">

                        <div class="flex-1">
                            <InputField 
                            :required="true" 
                            label="Nome *" 
                            type="text" 
                            placeHolder="Digite aqui o nome do usuário ..."
                            v-model="usuarioEdit.nome"
                            />
                        </div>

                        <div v-if="authStore.usuario.root" class="flex-1">
                            <SelectField
                            label="Parceria *"
                            labelOption="nome"
                            :options="getParcerias()"
                            placeHolder="Escolha uma parceria *"
                            valueProp="id"
                            :canClear="false"
                            v-model="usuarioEdit.parceriaId"
                            />
                        </div>

                    </div>

                </div>

                <div class="modal-footer p-3">

                    <ButtonField @click="closeModal" size="small" text="Fechar" type="light"></ButtonField>

                    <ButtonField size="small" text="Salvar" type="success" :submit="true" :isLoading="isLoading" :loadingText="'Atualizando usuário'"></ButtonField>

                </div>
            </form>

        </div>
    </div>

</template>

<script>
    import { useUsuariosStore } from '@/stores/usuarios';
    import { useParceriasStore } from '@/stores/parcerias.js';
    import { useAuthStore } from '@/stores/auth.js';
    import { toast } from 'vue3-toastify'

    export default{
        props:{
            isVisible : {
                type : Boolean,
                default: false
            },
            usuario: {
                type: Object
            }
        },
        emits:['close'],
        data(){
            return{
                usuariosStore : useUsuariosStore(),
                parceriasStore: useParceriasStore(),
                isLoading: false,
                usuarioEdit: {},
                authStore: useAuthStore()
            }
        },
        methods:{
            closeModal(){
                this.$emit('close');
            },
            async update(){

                this.isLoading = true

                const usuarioUpdate = {
                    id: this.usuarioEdit.id,
                    nome:  this.usuarioEdit.nome,
                    parceriaId:  this.usuarioEdit?.parceriaId
                }

                if (!usuarioUpdate.parceriaId) delete usuarioUpdate.parceriaId;

                const result = await this.usuariosStore.update(usuarioUpdate)
                this.isLoading = false

                if(result.status){
                    toast.success("Usuário editado com sucesso")
                    this.closeModal()
                    this.usuariosStore.get()
                }else{
                    toast.error(result.message)
                }

            },
            getParcerias(){
                const parcerias = this.parceriasStore.parcerias.filter(p => p.id != '')
                parcerias.unshift({id:'',nome:'Nenhuma'})
                return parcerias
            }
        },
        watch:{
            'usuario' : {
                handler(usuarioNew){
                    this.usuarioEdit = { ...usuarioNew }
                    if(!this.usuarioEdit.parceriaId) this.usuarioEdit.parceriaId = ''
                },
                immediate: true
            }
        },
        mounted() {
            if(this.authStore.usuario.root)
            {
                this.parceriasStore.get()
            }
        }
    }
</script>